import stroom from './assets/stroom.json';
import turbine from './assets/turbine.json';
import wind from './assets/wind.json';

export default {
  stroom,
  turbine,
  wind,
};
